import React, { useState } from 'react';
import { Star } from 'lucide-react';

export default function StarRating({ imageId, initialRating = 0, onRate, onChange }) {
  const [rating, setRating] = useState(initialRating);
  const [hoverRating, setHoverRating] = useState(0);

  const handleClick = (value) => {
    setRating(value);
    if (onRate) onRate(imageId, value);
    if (onChange) onChange();
    
    // localStorage speichern
    const ratings = JSON.parse(localStorage.getItem('snapshot_ratings') || '{}');
    ratings[imageId] = value;
    localStorage.setItem('snapshot_ratings', JSON.stringify(ratings));
  };

  return (
    <div className="flex items-center gap-1" onClick={(e) => e.stopPropagation()}>
      {[1, 2, 3, 4, 5].map((value) => (
        <button
          key={value}
          onClick={(e) => {
            e.stopPropagation();
            handleClick(value);
          }}
          onMouseEnter={() => setHoverRating(value)}
          onMouseLeave={() => setHoverRating(0)}
          className="transition-all hover:scale-110 cursor-pointer"
          style={{ pointerEvents: 'auto' }}
          type="button"
        >
          <Star
            className={`w-4 sm:w-5 h-4 sm:h-5 transition-all ${
              value <= (hoverRating || rating)
                ? 'fill-[#10B981] text-[#10B981]'
                : 'fill-none text-white/30'
            }`}
          />
        </button>
      ))}
    </div>
  );
}
